import { createContext, useContext } from 'react';

var Context = createContext(null);
var FlyoutProvider = Context.Provider;
var useFlyoutPortalElement = function useFlyoutPortalElement() {
  var _useContext;
  return ((_useContext = useContext(Context)) === null || _useContext === void 0 ? void 0 : _useContext.current) || document.body;
};

export { FlyoutProvider, useFlyoutPortalElement };
//# sourceMappingURL=FlyoutContext.js.map
